import { useState, useEffect } from "react";

/* Single interval, minimal re-renders */
const BrandingOverlay = () => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setPhase((p) => (p + 1) % 12), 5000);
    return () => clearInterval(iv);
  }, []);

  const labels = ["MANAGEMENT", "COACHING", "BRANDING", "FINANCE", "PUBLISHER", "PRODUCER"];
  const activeIdx = phase % 6;
  const showAlpha = phase % 2 === 0;

  return (
    <div data-testid="branding-overlay" className="absolute inset-0 pointer-events-none z-[12]">
      {/* Bottom-left branding */}
      <div className="absolute bottom-[6%] left-[22%] hidden lg:block">
        <span className="font-heading text-[10px] tracking-[0.4em] uppercase text-cyan-500/30 block">
          Dennis M. Postema
        </span>
        <div className="flex items-center gap-2 mt-0.5">
          {labels.map((l, i) => (
            <span key={i} className={`font-mono text-[7px] tracking-[0.15em] uppercase ${i === activeIdx ? "text-cyan-400/60" : "text-cyan-800/30"}`}>
              {l}
            </span>
          ))}
        </div>
      </div>

      {/* Bottom-center alternating text */}
      <div className="absolute bottom-[2.5%] left-1/2 -translate-x-1/2">
        <span className={`font-heading text-[8px] md:text-[9px] tracking-[0.4em] uppercase ${showAlpha ? "text-cyan-600/30" : "text-amber-600/20"}`}>
          {showAlpha ? "ALPHA GLOBAL ENTERPRISES" : "D|P // SECURE CHANNEL"}
        </span>
      </div>
    </div>
  );
};

export default BrandingOverlay;
